export class PermissionState {
  permissions: any;
}
